import { useContext } from 'react';

import DocumentContext from '@modules/documents/contexts/DocumentContext.context';

/** What the open document version means for the AI panel. All three values are false outside a document. */
const useAiOpenVersion = () => {
  const documentContext = useContext(DocumentContext);
  const doc = documentContext?.doc;
  const versionId = documentContext?.versionId;
  const hasDraft = Boolean(doc?.draft);

  return {
    hasDraft,
    // Looking at a completed version while a draft exists: Edit suggestions would land in the draft,
    // not in what the user is reading.
    isDraftOpenElsewhere: hasDraft && versionId !== 'draft',
    // Ask answers from the draft, or from the latest version when there is no draft. The FE lists
    // versions newest first, so versions[0] is the latest.
    isNotLatestVersionOpen: Boolean(doc) && versionId !== 'draft' && (hasDraft || versionId !== doc?.versions[0]?.id),
  };
};

export default useAiOpenVersion;
